'use es6';

const noopTracker = {
  track() {}

};
let tracker;
export const getUsageTracker = () => tracker || noopTracker;
export const setUsageTracker = usageTracker => tracker = usageTracker;